import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { Template } from "./page-content.templates";

const decorator = (Story) => html`
    <ux-iws-sf-page variant="center" class="ux-t-container-full"
        >${Story()}</ux-iws-sf-page
    >
`;

export default {
    title: "Salesforce/Components/Page Content",
    component: "ux-iws-sf-page-content",
    render: Template.bind({}),
    decorators: [decorator],
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    argTypes: {
        size: {
            control: {
                type: "select",
            },
            options: ["s", "m", "l"],
        },
        _slot: {
            table: {
                disable: true,
            },
        },
    },
    args: {
        _slot: `<ux-iws-sf-page-body>Content of the page.</ux-iws-sf-page-body>`,
    },
};

export const Default = {};

export const Sizes = {
    render: () => html`
        ${Template({
            size: "s",
            _slot: `<ux-iws-sf-page-body>Small content</ux-iws-sf-page-body>`,
        })}
        ${Template({
            size: "m",
            _slot: `<ux-iws-sf-page-body>Medium content</ux-iws-sf-page-body>`,
        })}
        ${Template({
            size: "l",
            _slot: `<ux-iws-sf-page-body>Large content</ux-iws-sf-page-body>`,
        })}
    `,
};
